<template>
    <div>
        <base-header type="gradient-primary" class="pb-6 pb-8 pt-5 pt-md-8">
            <v-card>
                <v-card-text>
                    <div class="table-responsive" id="printMe">
                        <div>
                            <div style=" text-align: center">
                                <h1 class="display-3 logoName">MSacco</h1>

                                <h5>P.O BOX 1919, 01000</h5>
                                <h5>Tel: 020678567 <span> Fax: 678457</span></h5>
                                <h5>Mobile: 078923778</h5>
                            </div><br>
                            <div class="row justify-content-between" style="margin-left: 3%">
                                <div class="col-6">

                                    <h5>Statement Date: {{statements.access_time}} </h5>
                                </div>

                            </div><br>
                        </div>
                        <table class="table  mb-0 table-bordered" style="text-align: center">
                            <thead class="bg-light">
                            <tr>
                                <th scope="col" rowspan="2">Date</th>
                                <th scope="col" rowspan="2">Type</th>
                                <th scope="col" colspan="2">Amount</th>
                            </tr>
                            <tr>
                                <th scope="col">Debit</th>
                                <th scope="col">Credit</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="information in statements.data" :key="information.statement_public_id">
                                <td>{{information.statement_date}}</td>
                                <td>{{information.statement_type}}</td>
                                <td>{{formatCost(information.debit)}}</td>
                                <td>{{formatCost(information.credit)}}</td>
                                </tr>
                            <tr>
                                <th colspan="2">Total</th>
                                <th>{{formatCost(statements.total_debit)}}</th>
                                <th>{{formatCost(statements.total_credit)}}</th>
                            </tr>
                            </tbody>
                        </table>
                    </div> <br>
                    <button type="button" class="btn btn-primary" >PRINT</button>
                </v-card-text>
            </v-card>
        </base-header>
    </div>
</template>

<script>
    export default {
        name: "saccoStatement",
        methods: {
            formatCost(amount) {
                const result = Number(amount).toLocaleString()
                if (result !== 0) {
                    return `Ksh. ${result}`;
                } else {
                    return '0';
                }
            },
        },
        created(){
            this.authorizedUser(this.authorizeAdminOnly);
            this.$store.dispatch('statements_function');
        },
    }
</script>

<style scoped>

</style>
